import { store } from '@sonifi/wb-core/store/store';
import {
  createSlide,
  getSlideToEdit,
  initHappeningsChannel,
} from '../services/happenings.service';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { cleanHappeningsSlideEditorSlice } from '../store/happeningsSlideEditorSlice';

function handleSlide(slideId) {
  store.dispatch(cleanHappeningsSlideEditorSlice());

  const isAddingNewSlide = slideId === 'add';
  const slideAction = isAddingNewSlide
    ? createSlide()
    : getSlideToEdit(slideId);

  store.dispatch(slideAction);
}

export async function loaderHappenings({ params }) {
  const { groupId, slideId } = params;

  const { loading, loadedGroupId } = store.getState().happenings;

  if (slideId) {
    handleSlide(slideId);
  }

  if (loading === LOADING_STATUS.success && loadedGroupId === parseInt(groupId)) {
    return {};
  }

  await store.dispatch(initHappeningsChannel(parseInt(groupId)));

  return {};
}
